var map = {
	"./animals/covers/bear-cover.jpg": 58667,
	"./animals/covers/bull-cover.jpg": 37118,
	"./animals/covers/butterfly-cover.jpg": 68520,
	"./animals/covers/camel-cover.jpg": 42963,
	"./animals/covers/cat-cover.jpg": 8049,
	"./animals/covers/cobra-cover.jpg": 50194,
	"./animals/covers/cow-cover.jpg": 25988,
	"./animals/covers/crocodile-cover.jpg": 78413,
	"./animals/covers/deer-cover.jpg": 43965,
	"./animals/covers/dog-cover.jpg": 55711,
	"./animals/covers/donkey-cover.jpg": 81769,
	"./animals/covers/eagle-cover.jpg": 86697,
	"./animals/covers/elephant-cover.jpg": 34682,
	"./animals/covers/galo-cover.jpg": 72618,
	"./animals/covers/goat-cover.jpg": 36424,
	"./animals/covers/horse-cover.jpg": 65794,
	"./animals/covers/lion-cover.png": 49815,
	"./animals/covers/monkey-cover.jpg": 81998,
	"./animals/covers/ostrich-cover.jpg": 83341,
	"./animals/covers/peacock-cover.jpg": 48855,
	"./animals/covers/pig-cover.jpg": 18833,
	"./animals/covers/rabbit-cover.jpg": 41029,
	"./animals/covers/ram-cover.jpg": 96445,
	"./animals/covers/tiger-cover.jpg": 12868,
	"./animals/covers/turkey-cover.jpg": 9111,
	"./animals/icons/bear-color.png": 5459,
	"./animals/icons/bull-color.png": 31326,
	"./animals/icons/butterfly-color.png": 86920,
	"./animals/icons/camel-color.png": 46443,
	"./animals/icons/cat-color.png": 45113,
	"./animals/icons/cobra-color.png": 70234,
	"./animals/icons/cow-color.png": 1084,
	"./animals/icons/crocodile-color.png": 18733,
	"./animals/icons/deer-color.png": 93869,
	"./animals/icons/dog-color.png": 31199,
	"./animals/icons/donkey-color.png": 78241,
	"./animals/icons/eagle-color.png": 2401,
	"./animals/icons/elephant-color.png": 57970,
	"./animals/icons/galo-color.png": 72690,
	"./animals/icons/goat-color.png": 11688,
	"./animals/icons/horse-color.png": 62714,
	"./animals/icons/lion-color.png": 66791,
	"./animals/icons/monkey-color.png": 53054,
	"./animals/icons/ostrich-color.png": 49597,
	"./animals/icons/peacock-color.png": 21255,
	"./animals/icons/pig-color.png": 48713,
	"./animals/icons/rabbit-color.png": 83973,
	"./animals/icons/ram-color.png": 2861,
	"./animals/icons/tiger-color.png": 21948,
	"./animals/icons/turkey-color.png": 41655,
	"./animals/info": 51519,
	"./animals/info.json": 51519,
	"./app-background.png": 72610,
	"./app-background2.png": 64458,
	"./bau-icon.png": 76578,
	"./bauzinho-card.png": 525,
	"./bolaoDezenas-card.png": 87706,
	"./bolaoDezenas-icon.png": 10151,
	"./casino-card.png": 17666,
	"./casino-chip.png": 9138,
	"./fichas-de-cassino.gif": 19322,
	"./flags/AC.png": 89644,
	"./flags/AL.png": 69531,
	"./flags/AM.png": 54706,
	"./flags/AP.png": 97143,
	"./flags/BA.png": 89055,
	"./flags/BR.png": 14516,
	"./flags/CE.png": 88556,
	"./flags/DF.png": 39286,
	"./flags/ES.png": 36704,
	"./flags/GO.png": 46850,
	"./flags/MA.png": 64266,
	"./flags/MG.png": 64604,
	"./flags/MS.png": 92168,
	"./flags/MT.png": 67335,
	"./flags/PA.png": 52757,
	"./flags/PB.png": 67006,
	"./flags/PE.png": 3121,
	"./flags/PI.png": 82317,
	"./flags/PR.png": 48142,
	"./flags/RJ.png": 65404,
	"./flags/RN.png": 50840,
	"./flags/RO.png": 71969,
	"./flags/RR.png": 81508,
	"./flags/RS.png": 35405,
	"./flags/SC.png": 93162,
	"./flags/SE.png": 64764,
	"./flags/SP.png": 84305,
	"./flags/TO.png": 18871,
	"./football.gif": 44068,
	"./footer/bank-transfer.svg": 16212,
	"./footer/boleto-bancario.svg": 70501,
	"./footer/pix.svg": 90561,
	"./hot-icon.svg": 75027,
	"./instantaneo-card.png": 16549,
	"./instantaneo-icon.png": 84268,
	"./ligeirinha-card.png": 3405,
	"./ligeirinha-icon.png": 84708,
	"./logo-brasao.png": 37036,
	"./logo.png": 33153,
	"./logo_color.svg": 32363,
	"./logo_small-bu.png": 50507,
	"./lotteries-icon.svg": 31601,
	"./lotteries/dia-de-sorte.png": 99666,
	"./lotteries/logo-dia-de-sorte-em-png.png": 95221,
	"./lotteries/logo-lotofacil-em-png.png": 27056,
	"./lotteries/logo-lotomania-em-png.png": 66989,
	"./lotteries/logo-mega-sena-em-png.png": 26447,
	"./lotteries/logo-quina-em-png.png": 81739,
	"./lotteries/lotofacil-png-1.png": 26657,
	"./lotteries/lotomania-png.png": 83084,
	"./lotteries/lt.png": 79062,
	"./lotteries/mega-sena-png.png": 4994,
	"./lotteries/quina.png": 48660,
	"./lotteries/quinabrasil.png": 73867,
	"./lotteries/quininha.png": 93489,
	"./lotteries/seninha.png": 67206,
	"./lotteries/trevo-gray.png": 50728,
	"./lotteries/trevo.png": 77314,
	"./lt-card.png": 43541,
	"./lt-icon.png": 73404,
	"./no-flag.png": 59530,
	"./password.svg": 83805,
	"./poker-card.gif": 62657,
	"./products-icon.svg": 55180,
	"./quinabrasil-card.png": 60762,
	"./quinabrasil-icon.png": 16359,
	"./quininha-card.png": 42056,
	"./quininha-icon.png": 27873,
	"./rifa-icon.png": 81092,
	"./seninha-card.png": 82181,
	"./seninha-icon.png": 76204,
	"./soccer-ball.png": 15063,
	"./soccer-cover.webp": 6024,
	"./ticket.png": 99136,
	"./tradicional-card.png": 2633,
	"./tradicional-icon.png": 70296,
	"./tradicional.gif": 84387,
	"./tradicional2-card.png": 66321,
	"./wealth-1.1s-200px.png": 66054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;